<template>
    <div class="project-container">
        <div style="color: #999; margin: 30px 0 10px 0;">当前位置：<span @click="goToList" style="cursor: pointer;">项目库</span> > {{ title }}</div>
        <div class="back">
            <el-button type="primary" @click="goToList">返回</el-button>
        </div>
        <el-table
                :data="projectList"
                style="width: 100%; margin-top: 20px; flex: 1; border: 1px solid #EBEEF5; border-radius: 4px; border-bottom: none;"
                class="project-table"
                height="1%"
                size="medium"
                row-key="id"
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                :header-cell-style="{ height: '42px', color: '#3E3E3E', background: '#F2F4F7', paddingLeft: '24px' }" :cell-style="{ height: '60px', color: '#333', paddingLeft: '24px' }">
            <el-table-column prop="project_title" label="项目名称"></el-table-column>
            <el-table-column label="时长" align="center">
                <template slot-scope="scope">
                    {{scope.row.project_duration * 45}}分钟
                </template>
            </el-table-column>
            <el-table-column prop="project_pv" label="浏览量" align="center"></el-table-column>
            <el-table-column label="难度" align="center" width="130px">
                <template slot-scope="scope">
                    <el-rate v-model="scope.row.project_difficulty" disabled></el-rate>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200px">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <el-link type="primary" @click="goToProjectDetail(scope.row)" :underline="false" style="color: #006EFF;margin: 1px 16px 0 0;">查看详情</el-link>
                        <span class="like" @click="dianzan(scope.row)" style="cursor: pointer;">
                        <template v-if="scope.row.project_live_num.length === 0">
                            <div style="display: flex; align-items: center;">       
                                <i class="iconfont" style="font-size: 13px;">&#xe756;</i>
                                <span style="margin-left: 4px;">收藏</span>
                            </div>
                        </template>
                        <template v-if="scope.row.project_live_num.length > 0">
                            <div style="display: flex; align-items: center;">
                                <i class="iconfont" style="color: #FF4242; font-size: 13px;">&#xe757;</i>
                                <span style="color: #FF4242; margin-left: 4px;">取消收藏</span>
                            </div>
                        </template>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 0"
                class="pages-center"
                :current-page="projectPages.currentPageNum"
                :page-size="projectPages.eachPageNum"
                layout="prev, pager, next" background
                :total="projectPages.total"
                @current-change="projectCurrentChange"
        ></el-pagination>
    </div>
</template>

<script>
    export default {
        name: "Project",
        data() {
            return {
                //项目列表
                projectList: [],
                //分类id
                resource_class_id: Number(this.$route.query.id) || '',
                //分页
                projectPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0
                },
                title: this.$route.query.title,
            }
        },
        mounted() {
            this.getProjectList();
        },
        methods: {
            //获取项目列表
            getProjectList() {
                let param = {
                    resource_class_id: this.resource_class_id
                }
                this.$shttp.axiosGetBy(this.$api.project_projectList, param, (res) => {
                    if (res.code === 200) {
                        this.projectList = res.data.list;
                        console.log(this.projectList);
                        this.projectList.total = res.data.total;
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //点赞
            dianzan(item) {
                this.$shttp.axiosGetBy(this.$api.project_dianZan, {project_id: item.id}, (res) => {
                    if (res.code === 200) {
                        this.getProjectList();
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //查看项目详情
            goToProjectDetail(item) {
                localStorage.setItem("project_id",item.id)
                localStorage.setItem("project_type",3)
                this.$router.push({
                    path: '/qualityCourse/project/detail',
                    query: {
                        p_id: item.id
                    },
                })
            },
            //分页
            projectCurrentChange(val) {
                this.projectPages.currentPageNum = val;
                this.getProjectList()
            },
            //返回
            goToList() {
                this.$router.push({
                    path: '/qualityCourse/projectclassify'
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .project-container {
        display: flex;
        flex-direction: column;
        padding: 20px 18.75%;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background-color: #fff;
        .project-table {
            ::v-deep table {
                ::v-deep td:last-child {
                    .cell {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .like {
                            cursor: pointer;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
        .difficulty {
            color: #FFD83E;
        }
        .pages-center {
            background-color: #fff;
            padding: 20px 0;
        }
    }
    .back {
        text-align: right;
    }
</style>